module.exports = __webpack_public_path__ + "media/balls-mini.8306e876.mp4";